<template>
  <div id="app">
    <!--<transition :name="transitionName"-->
                <!--mode="out-in">-->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" v-wechat-title="$route.meta.title"></router-view>
    <!--</transition>-->
  </div>
</template>
<script>

import {WeChatInfo} from "@/api/Login";
import wx from 'weixin-js-sdk'
import {SystemContent, SystemStatus} from "@/api/Login";

export default {
  name: 'App',

  data() {
    return {
      transitionName : 'fade',
        appId: '',
        nonceStr: '',
        timestamp: '',
        signature: '',
    }
  },

    mounted() {
        this.$nextTick(() => {
            //系统维护
            SystemContent()
                .then(res => {
                    localStorage.setItem('maintenance', res.data.value);
                });

            SystemStatus()
                .then();

            // this.requestWeChatInfo();
        });
    },

    methods: {
        requestWeChatInfo() {
            let url = location.href.split('#')[0];
            WeChatInfo(url)
                .then((response) => {
                    if (response.code === this.$API_CODE.OK) {
                        this.appId = response.data.appId;
                        this.nonceStr = response.data.nonceStr;
                        this.timestamp = response.data.timestamp;
                        this.signature = response.data.signature;
                        this.handleCode();
                    }
                })
        },

        //隐藏分享按钮
        handleCode() {
            wx.config({
                beta: true,
                debug: false,
                appId: this.appId, // 必填,公众号的唯一标识
                timestamp: this.timestamp, // 必填,生成签名的时间戳
                nonceStr: this.nonceStr, // 必填,生成签名的随机串
                signature: this.signature, // 必填,签名
                jsApiList: ['hideAllNonBaseMenuItem']
            });
            wx.ready(function () {
                // config信息验证成功后会执行ready方法,所有接口调用都必须在config接口获得结果之后
                // config 是一个客户端的异步操作,所以如果需要在页面加载时调用相关接口,则须把相关接口放在ready函数中调用来确保正确执行.对于用户触发是才调用的接口,则可以直接调用,不需要放在ready函数中
                //禁用右上角菜单按钮
                wx.hideAllNonBaseMenuItem();

            });

            /* 处理失败验证 */
            wx.error(function (res) {
                // config 信息验证失败会执行error函数,如签名过期导致验证失败,具体错误信息可以打开config的debug模式查看,也可以在返回的res参数中查看,对于SPA可以在这里更新签名
                alert('配置验证失败: ' + res.errMsg)
            })
        },
    },

  watch: {
    '$route' (to, from) {
        // this.requestWeChatInfo();
      let toDepth = to.meta;
      let fromDepth = from.meta;
      if (fromDepth > toDepth) {
        this.transitionName = 'fade-left'
      } else if (fromDepth < toDepth) {
        this.transitionName = 'fade-right'
      } else {
        this.transitionName = 'fade'
      }
    }
  }
}
</script>

<style>
  body {
    margin: 0px;
    background: #fdf9f7;
  }

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: absolute;
  width: 100%;
  height: 100%;
}

  input,textarea{
    -webkit-user-select:auto;
    -moz-user-select:auto;
    user-select:auto;
  }


  .toast{
    position: fixed;
    z-index: 2000;
    left: 50%;
    top:50%;
    transition:all .5s;
    -webkit-transform: translateX(-50%) translateY(-50%);
    -moz-transform: translateX(-50%) translateY(-50%);
    -ms-transform: translateX(-50%) translateY(-50%);
    -o-transform: translateX(-50%) translateY(-50%);
    transform: translateX(-50%) translateY(-50%);
    text-align: center;
    border-radius: 5px;
    color:#FFF;
    background: rgba(17, 17, 17, 0.7);
    padding: 1rem;
    font-size: 1rem;
    line-height: 1.5rem;


  }
</style>
